module.exports = __webpack_public_path__ + "static/media/ma_eurosBanner.01819f23.png";